import React from "react";
import PropTypes from "prop-types";
import statuses from "utils/static/statuses";

const Status = ({ id, withIcon, category, label }) => {
    const status = statuses[id];
    const statusLabel = status?.label || label || id;
    const statusCategory = status?.category || category || "default";

    return (
        <div className={`status status--${statusCategory}`}>
            {withIcon && status?.Icon}
            <span className="status__label">{statusLabel}</span>
        </div>
    );
};

Status.propTypes = {
    id: PropTypes.string.isRequired,
    withIcon: PropTypes.bool,
    category: PropTypes.string,
    label: PropTypes.string,
};

Status.defaultProps = {
    withIcon: false,
    category: undefined,
    label: undefined,
};

export default Status;
